import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.checklist.steps.title',
    defaultMessage: 'Etapas do checklist',
  },
  houseTitle: {
    id: 'app.containers.checklist.steps.houseTitle',
    defaultMessage: 'Imóvel',
  },
  houseDescription: {
    id: 'app.containers.checklist.steps.houseDescription',
    defaultMessage: 'Cômodos e itens gerais.',
  },
  externalAreaTitle: {
    id: 'app.containers.checklist.steps.externalAreaTitle',
    defaultMessage: 'Área externa',
  },
  externalAreaDescription: {
    id: 'app.containers.checklist.steps.externalAreaDescription',
    defaultMessage: 'Uso de área comum e acesso.',
  },
  generalConditionsTitle: {
    id: 'app.containers.checklist.steps.generalConditionsTitle',
    defaultMessage: 'Condições gerais',
  },
  generalConditionsDescription: {
    id: 'app.containers.checklist.steps.generalConditionsDescription',
    defaultMessage: 'Mobília, paredes, piso, etc.',
  },
  propertyAssessmentDescription: {
    id: 'app.containers.checklist.steps.propertyAssessmentDescription',
    defaultMessage: 'Elétrica, hidráulica e estrutura física.',
  },
});
